import React,{Component} from 'react';
import Slider from "react-slick";
import {Link} from 'react-router-dom';
import team1 from './../../images/team/pic1.jpg';
import team2 from './../../images/team/pic2.jpg';
import team3 from './../../images/team/pic3.jpg';
import team4 from './../../images/team/pic4.jpg';
import team5 from './../../images/team/pic5.jpg';
import team6 from './../../images/team/pic6.jpg';
import team7 from './../../images/team/pic7.jpg';
import team8 from './../../images/team/pic8.jpg';


const latestBlog = [
	{ image: team1, name: "Sakshi Bhadala", desc: "Dance and Music Teacher", },
	{ image: team2, name: "Anuradha Desai", desc: "Center Head", },
	{ image: team3, name: "Jenniffer", desc: "Teacher", },
	{ image: team4, name: "Vasavi", desc: "Teacher", },
	{ image: team5, name: "Puspalatha", desc: "Teacher", },
	{ image: team6, name: "Jarita", desc: "Daycare Cordinator", },
	{ image: team7, name: "Pushpalata", desc: "Teacher", },
	{ image: team8, name: "Gayatri", desc: "Teacher", },
];

class TeacherSlider extends Component{	
	constructor(props) {
		super(props);
		this.next = this.next.bind(this);
		this.previous = this.previous.bind(this);
	}
	next() {
		this.slider.slickNext();
	}
	previous() {
		this.slider.slickPrev();
	}
	render(){
		var settings = {		
			arrows: false,
            slidesToShow: 4,			
            infinite: true,
			autoplay: true,
			responsive: [
				{
				  breakpoint: 1200,
				  settings: {
					slidesToShow: 3,
				  }
				},
				{
				  breakpoint: 991,
				  settings: {
					slidesToShow: 3,
				  }
				},
				{
				  breakpoint: 576,
				  settings: {
					slidesToShow: 1,
				  }
				}
			]
        };
		return(
			<>	
				<div className="sprite-nav">
					<Slider className="team-carousel owl-carousel owl-theme dots-none  " ref={c => (this.slider = c)} {...settings}>
						{latestBlog.map((item, index) => (
							<div className="item">
								 <div className="dlab-box box-frame1 team-box">
									<div className="dlab-thum"> 
										<Link to={"/teachers-details"}>
											<img src={item.image} alt="" />
										</Link>
										<div className="overlay-bx">
											<h5 className="team-title" style={{ color: "#ed5ab0" }}>{item.name}</h5>
											<span className="team-info">{item.desc}</span>
											{/* <ul className="list-inline">
												<li><Link to={'#'}><i className="fa fa-facebook"></i></Link></li>
												<li><Link to={'#'}><i className="fa fa-google-plus"></i></Link></li>
												<li><Link to={'#'}><i className="fa fa-linkedin"></i></Link></li>
												<li><Link to={'#'}><i className="fa fa-instagram"></i></Link></li>
												<li><Link to={'#'}><i className="fa fa-twitter"></i></Link></li>
											</ul> */}
										</div>
									</div>
								</div>
							</div>
						))}	
					</Slider>		
					<div className="owl-nav" style={{ textAlign: "center" }}>
						<div className=" owl-prev " onClick={this.previous}/>
						<div className="owl-next " onClick={this.next}/>
					</div>
				</div>	
			</>	
		)
	}
}
export default TeacherSlider;